'use client'

import { clsx } from 'clsx'
import { ComponentPropsWithoutRef } from 'react'

interface SearchPickerOptionProps extends ComponentPropsWithoutRef<'div'> {}

/**
 * SearchPicker.Option - Individual Option Item
 *
 * **Role in Compound Structure:**
 * This is a low-level presentational component that renders a single selectable
 * option item. It's used by SearchPicker.DropdownContent but can also be used
 * in custom option rendering.
 *
 * **Responsibilities:**
 * - Renders a single option item with consistent styling
 * - Provides hover states and basic interactivity
 * - Accepts onClick and other standard div props
 * - Sets tabIndex={-1} to prevent tab navigation (keyboard nav handled by ListKeyboardNav)
 * - Used by SearchPicker.OptionsList for rendering option items
 */
const SearchPickerOption = ({ className, ...rest }: SearchPickerOptionProps) => {
    return (
        <div
            role="option"
            tabIndex={-1}
            className={clsx(
                'flex justify-start items-center gap-2 px-4 py-3',
                'hover:bg-grey-100 focus:bg-grey-100 focus:outline-none select-none',
                className,
            )}
            {...rest}
        />
    )
}

export default SearchPickerOption
